// Mock data for WorkLink Global - Will be replaced with backend integration

export const heroData = {
  tagline: "Australia's Trusted Workforce Aggregator",
  subheading: "Delivering skilled labour, subcontractors, and integrated workforce solutions across Australia.",
  strapline: "Workforce and supply coordination, simplified.",
  heroImage: "https://images.unsplash.com/photo-1740933084056-078fac872bff?w=1920&q=80"
};

export const valueProps = [
  { title: "Rapid Sourcing", icon: "Zap" },
  { title: "Verified Suppliers", icon: "CheckCircle" },
  { title: "Project-Based Pricing", icon: "DollarSign" },
  { title: "Nationwide Expansion", icon: "MapPin" },
  { title: "Compliance-Driven Delivery", icon: "Shield" }
];

export const industries = [
  {
    id: 1,
    name: "Construction & Civil",
    image: "https://images.unsplash.com/photo-1541888946425-d81bb19240f5?w=1200&q=80",
    description: "Skilled trades, labour, and supervision for major projects"
  },
  {
    id: 2,
    name: "Logistics & Distribution",
    image: "https://images.unsplash.com/photo-1644079446600-219068676743?w=1200&q=80",
    description: "Warehouse operations, drivers, and supply chain teams"
  },
  {
    id: 3,
    name: "Manufacturing",
    image: "https://images.unsplash.com/photo-1717386255773-1e3037c81788?w=1200&q=80",
    description: "Production line workers, technicians, and quality controllers"
  },
  {
    id: 4,
    name: "Cleaning & Facilities",
    image: "https://images.unsplash.com/photo-1742483359033-13315b247c74?w=1200&q=80",
    description: "Professional cleaning crews and facility maintenance teams"
  },
  {
    id: 5,
    name: "Hospitality",
    image: "https://images.unsplash.com/photo-1516788875874-c5912cae7b43?w=1200&q=80",
    description: "Front and back of house staff for venues and events"
  },
  {
    id: 6,
    name: "ICT & Professional Services",
    image: "https://images.unsplash.com/photo-1743175129533-1a59b078804f?w=1200&q=80",
    description: "Technical specialists and business support professionals"
  }
];

export const services = [
  {
    title: "Labour Hire & Subcontracting",
    description: "Skilled labour across all major industries with strict safety and insurance compliance.",
    icon: "Users"
  },
  {
    title: "Workforce Management Solutions",
    description: "End-to-end labour coordination, rostering, and centralised contract management.",
    icon: "Settings"
  },
  {
    title: "Materials & Supply Coordination",
    description: "Streamlined procurement and supply chain management through our trusted supplier network.",
    icon: "Package"
  },
  {
    title: "Compliance & Governance",
    description: "Verification of insurances, licences, and comprehensive WHS documentation control.",
    icon: "Shield"
  },
  {
    title: "Project Supervision",
    description: "Qualified Nominated Supervisors ensuring quality, safety, and performance standards.",
    icon: "Eye"
  }
];

export const complianceFeatures = [
  "Supplier verification",
  "Insurance and licence checks",
  "WHS documentation assessment",
  "Supervisor qualification checks",
  "Site visits and performance audits",
  "Non-compliance escalation procedures"
];

export const clientBenefits = [
  {
    title: "Single Point of Contact",
    description: "No more chasing multiple subcontractors — we manage everything.",
    icon: "MessageSquare"
  },
  {
    title: "Verified, Compliant Suppliers",
    description: "All suppliers undergo rigorous screening, licensing checks, insurance verification, and ongoing audits.",
    icon: "CheckCircle"
  },
  {
    title: "Rapid Mobilisation",
    description: "Access labour quickly through our multi-supplier network.",
    icon: "Zap"
  },
  {
    title: "Project-Based Pricing",
    description: "Transparent, market-aligned pricing suitable for project budgets.",
    icon: "DollarSign"
  },
  {
    title: "End-to-End Coordination",
    description: "From sourcing to supervision to performance monitoring.",
    icon: "GitBranch"
  }
];

export const supplierBenefits = [
  "Guaranteed jobs",
  "Competitive project-based rates",
  "Weekly payments",
  "Reduced administrative burden",
  "Access to major clients",
  "Sustainable pipelines of ongoing work",
  "Protection from client-side poaching",
  "Support with compliance and mobilisation"
];

export const aboutContent = {
  whoWeAre: "Worklink Global is a leading Australian workforce aggregator specialising in the strategic coordination of labour, subcontractors, and industry-specific service providers. Operating in NSW and expanding nationally, we bring together the capabilities of multiple pre-qualified suppliers to deliver seamless, high-performance workforce solutions.",
  mission: "To provide Australian industries with scalable, compliant, and reliable workforce solutions by connecting clients to a trusted network of labour partners and professional subcontractors.",
  vision: "To become Australia's most respected workforce aggregation platform, recognised for reliability, governance, and industry excellence.",
  image: "https://images.unsplash.com/photo-1600880292089-90a7e086ee0c?w=1200&q=80"
};

export const contactInfo = {
  email: "info@worklinkglobal.com.au",
  phone: "+61 406 955 576",
  location: "Unit 7B, 4 Brunker Road, Chullora NSW 2190",
  expansion: "Expansion to QLD & Nationwide"
};
